import { EMPTY_OBJECT, EMPTY_STRING } from '../../../constants/common'
import { EpostCell } from '../Epost.constants'
import {
  EPOST_FORM_FIELDS_NAME_C4_ENVELOPE,
  EPOST_FORM_FIELDS_NAME_COLOR,
  EPOST_FORM_FIELDS_NAME_LETTERS,
  EPOST_FORM_FIELDS_NAME_PAGES_COUNT,
  EPOST_FORM_FIELDS_NAME_PRINT_SIDE,
  EPOST_FORM_FIELDS_NAME_PROVIDER,
  EPOST_FORM_FIELDS_NAME_REGISTERED_LETTER,
  getEpostFormFieldsC4EnvelopeOptions,
  trasformEpostFormFieldsApiColorSchemeOptionValueToApiValue,
  trasformEpostFormFieldsPrinterSideOptionValueToApiValue,
} from '../EpostFormFields'

import { EPOST_FORM_PROVIDER } from './EpostForm.constants'

export function getEpostFormDefaultInitialValues(t) {
  return {
    [EPOST_FORM_FIELDS_NAME_C4_ENVELOPE]:
      getEpostFormFieldsC4EnvelopeOptions(t)[0],
    [EPOST_FORM_FIELDS_NAME_COLOR]: EMPTY_OBJECT,
    [EPOST_FORM_FIELDS_NAME_LETTERS]: EMPTY_STRING,
    [EPOST_FORM_FIELDS_NAME_PAGES_COUNT]: EMPTY_STRING,
    [EPOST_FORM_FIELDS_NAME_PRINT_SIDE]: EMPTY_OBJECT,
    [EPOST_FORM_FIELDS_NAME_PROVIDER]: EPOST_FORM_PROVIDER,
  }
}

export function getEpostFormSubmitPayload(values) {
  return {
    [EpostCell.C4Envelope]: values[EPOST_FORM_FIELDS_NAME_C4_ENVELOPE].value,
    [EpostCell.Color]:
      trasformEpostFormFieldsApiColorSchemeOptionValueToApiValue(
        values[EPOST_FORM_FIELDS_NAME_COLOR]
      ),
    [EpostCell.Duplex]: trasformEpostFormFieldsPrinterSideOptionValueToApiValue(
      values[EPOST_FORM_FIELDS_NAME_PRINT_SIDE]
    ),
    [EpostCell.RegisteredLetter]:
      values[EPOST_FORM_FIELDS_NAME_REGISTERED_LETTER]?.value ?? null,
    [EpostCell.Vendor]: values[EPOST_FORM_FIELDS_NAME_PROVIDER],
  }
}
